import { Field, FieldType, FieldGroup } from "../../../../entities/Metadata";
import { IWithName } from "../../../../entities/common";
import { nameof } from "../../../../store/services/metadataService";
import { StageTransitionApprovalDetails } from "../../../../store/StageTransitionApprovalStore";
import { DecisionDateField, ApproverField, DecisionMakersField, ApproverCommentField } from "../../commonFakeFields";

export { DecisionDateField, ApproverField, DecisionMakersField, ApproverCommentField };

export const Title: Field = {
    id: "title",
    name: nameof<IWithName>("Name"),
    type: FieldType.Text,
    isNative: false,
    isSystem: false,
    isCustom: false,
    label: "Project Name",
    isReadonly: true,
    isFake: true,
    group: FieldGroup.SystemFields,
    settings: {
        views: {
            list: {
                minWidth: 200,
                maxWidth: 300
            }
        }
    }
};

export const ProjectManagerField: Field = {
    id: "projectManager",
    name: "ProjectManager",
    type: FieldType.Resource,
    isNative: false,
    isSystem: false,
    isCustom: false,
    label: "Project Manager",
    isReadonly: true,
    isFake: true,
    group: FieldGroup.SystemFields,
    settings: {
        views: {
            list: {
                minWidth: 160,
                maxWidth: 240
            }
        }
    }
};

export const TransitionFromStageField: Field = {
    id: "transitionFromStage",
    name: nameof<StageTransitionApprovalDetails>("stage"),
    type: FieldType.Text,
    isNative: false,
    isSystem: false,
    isCustom: false,
    label: "Transition From Stage",
    isReadonly: true,
    isFake: true,
    group: FieldGroup.SystemFields,
    settings: {
        views: {
            list: {
                minWidth: 160,
                maxWidth: 220
            }
        }
    }
};

export const TransitionToStageField: Field = {
    id: "transitionToStage",
    name: nameof<StageTransitionApprovalDetails>("nextStage"),
    type: FieldType.Text,
    isNative: false,
    isSystem: false,
    isCustom: false,
    label: "Transition To Stage",
    isReadonly: true,
    isFake: true,
    group: FieldGroup.SystemFields,
    settings: {
        views: {
            list: {
                minWidth: 160,
                maxWidth: 220
            }
        }
    }
};

export const stageTransitionFakeFields: Field[] = [
    Title,
    ProjectManagerField,
    TransitionFromStageField,
    TransitionToStageField,
    DecisionDateField,
    ApproverField,
    DecisionMakersField,
    ApproverCommentField
];

export const stageTransitionFilterableFakeFields: Field[] = [
    Title,
    ProjectManagerField,
    TransitionFromStageField,
    TransitionToStageField,
    DecisionDateField,
    ApproverField,
    DecisionMakersField,
    ApproverCommentField
];
